export default __webpack_public_path__ + "static/media/spaceShipH3.6ea4f8d0.webp";